import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import DrawerLayout from 'Components/Layout/Templates/DrawerLayout'
import { GroupType, isAuthorityAdmin, isSuperuser } from 'Services/common/Features/User/userSlice'
import AffiliateProduct from 'Services/SalesManagement/Features/AffiliateProduct'
import Campaign from 'Services/SalesManagement/Features/Campaign'
import FaultReport from 'Services/SalesManagement/Features/FaultReport'
import { HomePage } from 'Services/SalesManagement/Features/Home/Pages'
import Notification from 'Services/SalesManagement/Features/Notification'
import Order from 'Services/SalesManagement/Features/Order'
import Report from 'Services/SalesManagement/Features/Report'
import TicketSaleRoot from 'Services/SalesManagement/Features/TicketSale'
import WalttiPosRemoteConfig from 'Services/SalesManagement/Features/WalttiPosRemoteConfig'
import ZoneInfo from 'Services/SalesManagement/Features/ZoneInfo'
import useTypedSelector from 'Store'
import { LOGIN_PAGE_PATH, SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import { Route, Routes } from 'react-router-dom'
import { t } from 'ttag'

function SalesManagement() {
  const { authed: isAuthed, user } = useTypedSelector(state => state.user)

  const drawerMenuNavLinks: NavLinkItem[] = [
    {
      title: t`Home`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/`
    },
    {
      title: t`Orders`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/orders`,
      subMenuItems: [
        {
          title: t`Waltti webshop`,
          link: `${SALES_MANAGEMENT_ROOT_URL}/orders/webshop-orders`
        },
        {
          title: t`Mobile`,
          link: `${SALES_MANAGEMENT_ROOT_URL}/orders/mobile-orders`
        },
        {
          title: t`Points of sale`,
          link: `${SALES_MANAGEMENT_ROOT_URL}/orders/walttipos-orders`
        }
      ]
    },
    {
      title: t`Transfer management`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/transfer-management`
    },
    {
      title: t`Reports`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/reports`
    },
    {
      title: t`Notifications`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/notifications`,
      allowedGroups: [GroupType.authorityAdmin]
    },
    {
      title: t`Campaigns`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/campaigns`,
      allowedGroups: [GroupType.authorityAdmin]
    },
    {
      title: t`Remote Configurations`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/walttipos-remote-config`,
      allowedGroups: [GroupType.authoritySuperuser]
    },
    {
      title: t`Zone infos`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/zone-infos`,
      allowedGroups: [GroupType.authoritySuperuser]
    },
    {
      title: t`Ticket sales`,
      link: `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales`,
      subMenuItems: [
        {
          title: t`QR group tickets`,
          link: `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/qr-group-ticket-sales`
        },
        {
          title: t`Targets`,
          link: `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/ticket-sale-targets`
        }
      ],
      allowedGroups: [GroupType.authorityAdmin]
    }
  ]

  return (
    <Routes>
      <Route
        element={
          <DrawerLayout rootUrl="/sales-management/" drawerMenuNavLinks={drawerMenuNavLinks} />
        }
        path="/"
      >
        <Route index element={<HomePage />} />
        <Route path="/fault-reports/*" element={<FaultReport />} />
        <Route path="/orders/*" element={<Order />} />
        <Route path="/transfer-management/*" element={<AffiliateProduct />} />
        <Route path="/reports/*" element={<Report />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isAuthorityAdmin(user) || isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/notifications/*"
        >
          <Route path="*" element={<Notification />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/walttipos-remote-config/*"
        >
          <Route path="*" element={<WalttiPosRemoteConfig />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isAuthorityAdmin(user) || isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/campaigns/*"
        >
          <Route path="*" element={<Campaign />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/zone-infos/*"
        >
          <Route path="*" element={<ZoneInfo />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isAuthorityAdmin(user) || isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/ticket-sales/*"
        >
          <Route path="*" element={<TicketSaleRoot />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default SalesManagement
